import { apiClient } from '@/shared/lib/apiClient';
import type { ApiSuccessResponse } from '@super-admin/shared-types';

export type PortalUpgradePaymentProvider = 'myfatoorah' | 'instapay';

export type StartPortalUpgradeInput = {
  targetPlanCode: string;
  billingCycle: 'monthly' | 'yearly';
  paymentProvider: PortalUpgradePaymentProvider;
  locale?: 'ar' | 'en';
  idempotencyKey: string;
};

export type PortalUpgradeResponse =
  | {
      payment_provider: 'myfatoorah';
      payment_id: string;
      payment_url: string;
      status: 'pending';
      amount_minor: number;
      currency: string;
      purpose: 'upgrade';
    }
  | {
      payment_provider: 'instapay';
      payment_id: string;
      status: 'pending_review';
      review_status: 'pending_review';
      amount_minor: number;
      currency: string;
      purpose: 'upgrade';
      requires_receipt: true;
      temporary_access_until: string | null;
    };

export async function startPortalUpgrade(
  input: StartPortalUpgradeInput,
): Promise<PortalUpgradeResponse> {
  const res = await apiClient.post<ApiSuccessResponse<PortalUpgradeResponse>>(
    '/api/v1/customer/subscription/upgrade',
    {
      targetPlanCode: input.targetPlanCode,
      billingCycle: input.billingCycle,
      paymentProvider: input.paymentProvider,
      locale: input.locale,
    },
    {
      headers: { 'Idempotency-Key': input.idempotencyKey },
    },
  );

  return res.data;
}

export async function uploadPortalUpgradeInstapayProof(
  paymentId: string,
  file: File,
): Promise<void> {
  const form = new FormData();
  form.append('receipt', file);

  await apiClient.postForm<ApiSuccessResponse<void>>(
    `/api/v1/customer/subscription/upgrade/${paymentId}/instapay-proof`,
    form,
    {
      headers: { 'Idempotency-Key': crypto.randomUUID() },
    },
  );
}
